export const countriesValueToBeShownOnTop = ["JP"];

export let cancelParamSplitterStr = "DAS###";

export const apmKeys = [ "hasGooglePay", "hasApplePay", "hasPayPay"] 
export const apmKeyApplePayKey = "hasApplePay";

export const cardinalEnabledAcquirer: string[] = ["cybersource","WORLDPAY"];